import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Select, ValueButton } from "@activecollab/components";
import PropTypes from "prop-types";

export const GroupByPicker = ({ selected, options, onChange, ...rest }) => {
  const { t } = useTranslation();

  const labelText = useMemo(() => {
    return options.find((option) => option.id === selected)?.name;
  }, [selected, options]);

  const [open, setOpen] = useState(false);
  const onSelectOpen = useCallback(() => setOpen(true), []);
  const onSelectClose = useCallback(() => setOpen(false), []);

  return (
    <Select
      options={options}
      target={
        <ValueButton
          active={open}
          value={labelText}
          label={t("Group By")}
        />
      }
      onChange={onChange}
      selected={selected}
      onSelectOpen={onSelectOpen}
      onSelectClose={onSelectClose}
      {...rest}
    />
  );
};

GroupByPicker.propTypes = {
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options: PropTypes.array,
  onChange: PropTypes.func,
};

GroupByPicker.defaultProps = {
  options: [],
};
